import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Card, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BagType from 'ui-component/BagType';

const ROWS = [
    {
        sl: 1,
        bagTypeId: 0,
        label: 'Yellow',
        countKey: 'totalYellowBags',
        manualCountKey: 'totalYellowManualBags',
        weightKey: 'totalWeightofYellowBags'
    },
    {
        sl: 2,
        bagTypeId: 1,
        label: 'Red',
        countKey: 'totalRedBags',
        manualCountKey: 'totalRedManualBags',
        weightKey: 'totalWeightofRedBags'
    },
    {
        sl: 3,
        bagTypeId: 2,
        label: 'White',
        countKey: 'totalWhiteBags',
        manualCountKey: 'totalWhiteManualBags',
        weightKey: 'totalWeightofWhiteBags'
    },
    {
        sl: 4,
        bagTypeId: 3,
        label: 'Blue',
        countKey: 'totalBlueBags',
        manualCountKey: 'totalBlueManualBags',
        weightKey: 'totalWeightofBlueBags'
    },
    {
        sl: 5,
        bagTypeId: 4,
        label: 'Yellow - C',
        countKey: 'totalYellowCBags',
        manualCountKey: 'totalYellowCManualBags',
        weightKey: 'totalWeightofYellowCBags'
    }
];

const ReportTableTotal = (props) => {
    const { reportData, weightMode } = props;
    const theme = useTheme();

    if (!reportData) return null;

    const showManualCount = weightMode === 'manual';

    return (
        <Card variant="outlined" sx={{ marginTop: 2 }}>
            <TableContainer>
                <Table size="small">
                    <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                        <TableRow>
                            <TableCell sx={{ width: 60 }}>Sl.</TableCell>
                            <TableCell sx={{ width: 200 }} align="left">
                                Bag Type
                            </TableCell>
                            <TableCell sx={{ width: 150 }} align="left">
                                Bag Count
                            </TableCell>

                            <TableCell sx={{}} align="left">
                                Weight (Kg.)
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ROWS.map((row) => (
                            <TableRow key={row.sl}>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">{row.sl}</Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <BagType bagType={row.bagTypeId} />
                                        <Typography variant="body2">{row.label}</Typography>
                                    </Stack>
                                </TableCell>
                                {showManualCount ? (
                                    <TableCell align="left">
                                        <Typography variant="body2">{reportData[row.manualCountKey]}</Typography>
                                    </TableCell>
                                ) : (
                                    <TableCell align="left">
                                        <Typography variant="body2">{reportData[row.countKey]}</Typography>
                                    </TableCell>
                                )}
                                <TableCell align="left">
                                    <Typography variant="body2">{reportData[row.weightKey]}</Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell />
                            <TableCell align="left">
                                <Typography variant="h5">Total</Typography>
                            </TableCell>

                            {showManualCount ? (
                                <TableCell align="left">
                                    <Typography variant="h5">{reportData.totalManualBags}</Typography>
                                </TableCell>
                            ) : (
                                <TableCell align="left">
                                    <Typography variant="h5">{reportData.totalBags}</Typography>
                                </TableCell>
                            )}
                            <TableCell align="left">
                                <Typography variant="h5">{reportData.totalWeight}</Typography>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
    );
};

export default ReportTableTotal;
